import "./VideoPage.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import SingleVideoRight from "./SingleVideoRight";
import SingleVideoLeft from "./SingleVideoLeft";
import ReactPlayer from "react-player";
import { useState, useEffect, useRef, useContext } from "react";
import { useParams, useLocation } from "react-router-dom";
import {
  videoFetcher,
  specialVideoFetcher,
  viewsFetcher,
  historyFetcher,
  campaignFetcher,
  repostFetcher,
} from "../../api/requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faThumbsUp,
  faThumbsDown,
  faShare,
  faBookmark,
  faRetweet,
} from "@fortawesome/free-solid-svg-icons";
import { useToaster } from "../../context/toaster";
import { Spinner } from "react-bootstrap";
import { baseURL } from "../../api/dataFetcher";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom";
import { faBookmark as unFilledBookmark } from "@fortawesome/free-regular-svg-icons";
import Modal from "../Atomics/Modal";
import RepostModal from "./RepostModal";
import { ChannelContextProvider } from "../../context/channels";

const VideoPage = () => {
  const [video, setVideo] = useState(null);
  const [userHasLiked, setUserHasLiked] = useState(false);
  const [userHasDisliked, setUserHasDisliked] = useState(false);
  const [userHasReposted, setUserHasReposted] = useState(false);
  const [openRepostModal, setOpenRepostModal] = useState(false);
  const { id } = useParams();
  const location = useLocation();
  const videoType = location.pathname.includes("special");
  const { addMessage } = useToaster();
  const [isBuffering, setIsBuffering] = useState(false);
  const [playedPercentage, setPlayedPercentage] = useState(0);
  const [startPercentage, setStartPercentage] = useState(0);
  const playerRef = useRef(null);
  const [videoDuration, setVideoDuration] = useState(0);
  const history = useHistory();
  const [bookmark, setBookmark] = useState(false);
  const [savedObject, setSavedObject] = useState(null);
  const campaignId = new URLSearchParams(location.search).get("campaign");
  const campaignCategory = new URLSearchParams(location.search).get("category");
  const [interactionIDs, setInteractionIDs] = useState({
    likeId: 0,
    dislikeId: 0,
    saveId: 0,
  });
  const [isPortraitVideo, setIsPortraitVideo] = useState(false);
  const user = Cookies.get("vaghfnamaUser");
  let userId;
  if (user) {
    userId = JSON.parse(user).user_id;
  }

  useEffect(() => {
    // Reset portrait detection when video changes
    setIsPortraitVideo(false);

    const fetchVideoData = async () => {
      try {
        let videoData;

        if (campaignId) {
          if (userId) {
            const isVideoLiked = await campaignFetcher.isVideoLiked(
              userId,
              Number(id)
            );
            isVideoLiked?.count && setUserHasLiked(true);
            setInteractionIDs((prev) => ({
              ...prev,
              likeId: isVideoLiked?.results[0]?.id,
            }));

            const isVideoDisliked = await campaignFetcher.isVideoDisliked(
              userId,
              Number(id)
            );
            isVideoDisliked?.count && setUserHasDisliked(true);
            setInteractionIDs((prev) => ({
              ...prev,
              dislikeId: isVideoDisliked?.results[0]?.id,
            }));

            const isVideoSaved = await campaignFetcher.isVideoSaved(
              userId,
              Number(id)
            );
            isVideoSaved?.count && setBookmark(true);
            setInteractionIDs((prev) => ({
              ...prev,
              saveId: isVideoSaved?.results[0]?.id,
            }));
            setSavedObject(isVideoSaved);
          }
        } else {
          if (userId) {
            const isVideoLiked = await videoFetcher.isVideoLiked(
              userId,
              Number(id)
            );
            isVideoLiked.count && setUserHasLiked(true);
            setInteractionIDs((prev) => ({
              ...prev,
              likeId: isVideoLiked?.results[0]?.id,
            }));

            const isVideoDisliked = await videoFetcher.isVideoDisliked(
              userId,
              Number(id)
            );
            isVideoDisliked.count && setUserHasDisliked(true);
            setInteractionIDs((prev) => ({
              ...prev,
              dislikeId: isVideoDisliked?.results[0]?.id,
            }));

            try {
              const isVideoReposted = await repostFetcher.isVideoReposted(
                Number(id)
              );
              isVideoReposted?.is_reposted_by_me
                ? setUserHasReposted(true)
                : setUserHasReposted(false);
            } catch (err) {
              setUserHasReposted(false);
            }

            const isVideoSaved = await videoFetcher.isVideoSavedByUser(
              userId,
              Number(id)
            );
            isVideoSaved.count && setBookmark(true);
            setInteractionIDs((prev) => ({
              ...prev,
              saveId: isVideoSaved?.results[0]?.id,
            }));
            setSavedObject(isVideoSaved);
          }
        }

        if (videoType) {
          videoData = await specialVideoFetcher.getEachVideo(Number(id));
        } else if (campaignId) {
          const fetchedData = await campaignFetcher.getCampaignVideos({
            campaignId: campaignId,
            category: campaignCategory,
          });

          videoData = fetchedData.results?.find(
            (video) => video.id === Number(id)
          );
        } else {
          videoData = await videoFetcher.getEachVideo(Number(id));
        }

        setVideo(videoData);

        if (user && !campaignId) {
          const historyResponse = await historyFetcher.getEachVideo(Number(id));
          if (historyResponse.results[0]) {
            setStartPercentage(
              Math.floor(historyResponse.results[0].percentage_watched) / 100
            );
          }
        }
      } catch (error) {
        console.error("Error fetching video or bookmark data:", error);
      }
    };

    fetchVideoData();
    // getVideoStream();
  }, [id, campaignId]);

  useEffect(() => {
    const fetchVideoData = async () => {
      try {
        if (campaignId) {
          const isVideoLiked = await campaignFetcher.isVideoLiked(
            userId,
            Number(id)
          );
          isVideoLiked?.count && setUserHasLiked(true);
          setInteractionIDs((prev) => ({
            ...prev,
            likeId: isVideoLiked?.results[0]?.id,
          }));
        } else {
          const isVideoLiked = await videoFetcher.isVideoLiked(
            userId,
            Number(id)
          );
          isVideoLiked.count && setUserHasLiked(true);
          setInteractionIDs((prev) => ({
            ...prev,
            likeId: isVideoLiked?.results[0]?.id,
          }));
        }
      } catch (error) {
        console.error("Error fetching video or bookmark data:", error);
      }
    };

    if (user) fetchVideoData();
  }, [userHasLiked]);

  useEffect(() => {
    const fetchVideoData = async () => {
      try {
        if (campaignId) {
          const isVideoDisliked = await campaignFetcher.isVideoDisliked(
            userId,
            Number(id)
          );
          isVideoDisliked?.count && setUserHasDisliked(true);
          setInteractionIDs((prev) => ({
            ...prev,
            dislikeId: isVideoDisliked?.results[0]?.id,
          }));
        } else {
          const isVideoDisliked = await videoFetcher.isVideoDisliked(
            userId,
            Number(id)
          );
          isVideoDisliked.count && setUserHasDisliked(true);
          setInteractionIDs((prev) => ({
            ...prev,
            dislikeId: isVideoDisliked?.results[0]?.id,
          }));
        }
      } catch (error) {
        console.error("Error fetching video or bookmark data:", error);
      }
    };

    if (user) fetchVideoData();
  }, [userHasDisliked]);

  useEffect(() => {
    const fetchVideoData = async () => {
      try {
        if (campaignId) {
          const isVideoSaved = await campaignFetcher.isVideoSaved(
            userId,
            Number(id)
          );
          isVideoSaved?.count && setBookmark(true);
          setInteractionIDs((prev) => ({
            ...prev,
            saveId: isVideoSaved?.results[0]?.id,
          }));
        } else {
          const isVideoSaved = await videoFetcher.isVideoSaved(Number(id));
          isVideoSaved.count && setBookmark(true);
          setInteractionIDs((prev) => ({
            ...prev,
            saveId: isVideoSaved?.results[0]?.id,
          }));
        }
      } catch (error) {
        console.error("Error fetching video or bookmark data:", error);
      }
    };

    if (user) fetchVideoData();
  }, [bookmark]);

  const handleLikeClick = async (type) => {
    if (video && user) {
      try {
        if (type === "like") {
          if (!userHasLiked) {
            if (campaignId) {
              await campaignFetcher.like({ video_post: video.id });
            } else {
              await videoFetcher.like({ video_post: video.id });
            }

            setUserHasLiked(true);
            setUserHasDisliked(false);
            setVideo((prevVideo) => ({
              ...prevVideo,
              counted_like: prevVideo.counted_like + 1,
              counted_dislike: userHasDisliked
                ? prevVideo.counted_dislike - 1
                : prevVideo.counted_dislike,
            }));
          } else {
            if (campaignId) {
              await campaignFetcher.removeLike(interactionIDs.likeId);
            } else {
              await videoFetcher.removeLike(interactionIDs.likeId);
            }

            setUserHasLiked(false);
            setUserHasDisliked(false);
            setVideo((prevVideo) => ({
              ...prevVideo,
              counted_like: prevVideo.counted_like - 1,
            }));
          }
        } else if (type === "dislike") {
          if (!userHasDisliked) {
            if (campaignId) {
              await campaignFetcher.dislike({ video_post: video.id });
            } else {
              await videoFetcher.dislike({ video_post: video.id });
            }

            setUserHasDisliked(true);
            setUserHasLiked(false);
            setVideo((prevVideo) => ({
              ...prevVideo,
              counted_dislike: prevVideo.counted_dislike + 1,
              counted_like: userHasLiked
                ? prevVideo.counted_like - 1
                : prevVideo.counted_like,
            }));
          } else {
            if (campaignId) {
              await campaignFetcher.removeDisike(interactionIDs.dislikeId);
            } else {
              await videoFetcher.removeDisike(interactionIDs.dislikeId);
            }

            setUserHasDisliked(false);
            setUserHasLiked(false);
            setVideo((prevVideo) => ({
              ...prevVideo,
              counted_dislike: prevVideo.counted_dislike - 1,
            }));
          }
        }
      } catch (error) {
        console.error("Error updating likes/dislikes:", error);
        showToast(
          "error",
          error.response.data.detail.includes("قبلا")
            ? type === "like"
              ? "شما قبلا ویدئو اصلی را لایک کرده اید."
              : "شما قبلا ویدئو اصلی را دیسلایک کرده اید."
            : error.response.data.detail
        );
      }
    } else {
      history.push("/auth/login/");
    }
  };

  const handleShareClick = async () => {
    if (campaignId) {
      try {
        await campaignFetcher.postShare(id);
      } catch (err) {
        console.error(err);
      }
    } else {
      try {
        await videoFetcher.postShare(id);
      } catch (err) {
        console.error(err);
      }
    }

    const currentUrl = window.location.href;
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        showToast("success", "لینک صفحه در کلیپبورد کپی شد.");
      })
      .catch((err) => {
        console.error("Failed to copy the URL to clipboard:", err);
        showToast("error", "خطایی رخ داد.");
      });
  };

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleProgress = (e) => {
    const video = e.target;
    if (video.duration) {
      const watchedPercentage = (video.currentTime / video.duration) * 100;
      setPlayedPercentage(watchedPercentage);
    }
  };

  const handleHistoryPost = async () => {
    try {
      const historyResponse = await historyFetcher.getEachVideo(Number(id));

      if (historyResponse.results[0]?.id) {
        await historyFetcher.put(historyResponse.results[0]?.id, {
          video: id,
          percentage_watched: playedPercentage,
        });
      } else {
        await historyFetcher.post({
          video: id,
          percentage_watched: playedPercentage,
          user: userId,
        });
      }
    } catch (error) {
      console.error("Failed to update history:", error);
    }
  };

  const handleBookmarkClick = async () => {
    try {
      if (!bookmark) {
        if (!user) {
          history.push("/auth/login/");
          return;
        }

        let res;
        if (campaignId) {
          res = await campaignFetcher.save({ video_post: Number(id) });
        } else {
          res = await videoFetcher.save({ video_post: Number(id) });
        }

        if (res) {
          setSavedObject(res);
          setBookmark(true);
          setInteractionIDs((prev) => ({
            ...prev,
            saveId: res?.id,
          }));
        } else {
          console.error("Failed to bookmark video: No ID in response.");
        }
      } else {
        let res;
        if (campaignId) {
          res = await campaignFetcher.deleteSave(interactionIDs?.saveId);
        } else {
          res = await videoFetcher.deleteSave(interactionIDs?.saveId);
        }

        if (res.message) {
          setSavedObject(null);
          setBookmark(false);
          setInteractionIDs((prev) => ({
            ...prev,
            saveId: 0,
          }));
        } else {
          console.error("Failed to remove bookmark:", res);
        }
      }
    } catch (err) {
      console.error("Error handling bookmark click:", err);

      showToast(
        "error",
        err.response.data.detail.includes("قبلا")
          ? "شما قبلا ویدئو اصلی را ذخیره کرده اید."
          : err.response.data.detail
      );
    }
  };

  useEffect(() => {
    if (Math.floor(playedPercentage) % 10 === 0 && user && !campaignId)
      handleHistoryPost();
  }, [playedPercentage]);

  const handleReady = () => {
    if (playerRef.current) {
      const videoWidth = playerRef.current.videoWidth;
      const videoHeight = playerRef.current.videoHeight;
      setIsPortraitVideo(videoHeight > videoWidth);

      if (startPercentage > 0 && playerRef.current.duration) {
        playerRef.current.currentTime =
          startPercentage * playerRef.current.duration;
      }
    }
  };

  const handleDuration = (e) => {
    const video = e.target;
    setVideoDuration(video.duration);
  };

  return (
    <ContentWrapper>
      <Container fluid style={{ paddingLeft: "30px", paddingRight: "30px" }}>
        <div
          className="video-block-right-list section-padding"
          style={{ minHeight: "calc(100vh - 135px)" }}
        >
          <Row
            className="mb-4"
            style={{
              paddingLeft: "30px",
              paddingRight: "30px",
              paddingTop: "30px",
            }}
          >
            <Col md={8}>
              {
                <div className="single-video" style={{ position: "relative" }}>
                  {video ? (
                    <div
                      className={
                        isPortraitVideo
                          ? "video-player-wrapper portrait"
                          : "video-player-wrapper landscape"
                      }
                    >
                      <video
                        className="myVideoPlayer"
                        ref={playerRef}
                        src={
                          campaignId
                            ? `https://vaghfnama.ir/api/campaigns/api/v1/campaign_video_posts/${id}/stream/`
                            : `https://vaghfnama.ir/api/channels/api/v1/video_posts/${id}/stream/`
                        }
                        controls
                        autoPlay
                        muted
                        loop={false}
                        preload="metadata"
                        onLoadedMetadata={handleReady}
                        onTimeUpdate={handleProgress}
                        onPause={user ? handleHistoryPost : undefined}
                        onDurationChange={handleDuration}
                      >
                        {" "}
                        مرورگر شما از ویدئو پشتیبانی نمی‌کند.{" "}
                      </video>
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "55vh",
                      }}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <img
                        src={
                          video?.cover ? baseURL + video.cover : "/img/v4.png"
                        }
                        alt="Video Cover"
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          zIndex: -1,
                        }}
                      />
                      <Spinner animation="border" role="status" />
                    </div>
                  )}
                  {isBuffering && video && (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        zIndex: 10,
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          backgroundColor: "rgba(0, 0, 0, 0.3)",
                          zIndex: 1,
                        }}
                      ></div>
                      <Spinner
                        animation="border"
                        role="status"
                        style={{ zIndex: 2 }}
                      />
                    </div>
                  )}

                  <div className="reviews-members-footer mt-2 mb-2">
                    <span
                      className={`total-like ${
                        userHasLiked ? "activeLike" : ""
                      }`}
                      onClick={() => handleLikeClick("like")}
                    >
                      <FontAwesomeIcon icon={faThumbsUp} />

                      {video?.counted_like > 0 ? " " + video.counted_like : ""}
                    </span>
                    <span
                      className={`total-like mr-2 ${
                        userHasDisliked ? "activeLike" : ""
                      }`}
                      onClick={() => handleLikeClick("dislike")}
                    >
                      <FontAwesomeIcon icon={faThumbsDown} />

                      {video?.counted_dislike > 0
                        ? " " + video.counted_dislike
                        : ""}
                    </span>
                    <span
                      className={`total-like mr-2`}
                      onClick={handleShareClick}
                    >
                      <FontAwesomeIcon icon={faShare} />

                      {video?.counted_share > 0
                        ? " " + video.counted_share
                        : ""}
                    </span>
                    {!campaignId && (
                      <span
                        className={`total-like mr-2 ${
                          userHasReposted ? "activeLike" : ""
                        }`}
                        onClick={() =>
                          userId
                            ? setOpenRepostModal(true)
                            : history.push("/auth/login/")
                        }
                        title="بازنشر"
                      >
                        <FontAwesomeIcon icon={faRetweet} size="lg" />
                        {video?.counted_repost > 0
                          ? " " + video.counted_repost
                          : ""}
                      </span>
                    )}

                    <span
                      className={`total-like mr-2`}
                      onClick={handleBookmarkClick}
                    >
                      <FontAwesomeIcon
                        icon={bookmark ? faBookmark : unFilledBookmark}
                      />
                      &nbsp;
                      {video?.counted_save > 0 ? " " + video.counted_save : ""}
                    </span>
                  </div>
                </div>
              }

              <div className="video-block section-padding">
                <Row>
                  <Col md={12}>
                    <SingleVideoLeft video={video} />
                  </Col>
                </Row>
              </div>
            </Col>

            <Col md={4}>
              <SingleVideoRight video={video} />
            </Col>
          </Row>
        </div>

        {openRepostModal && (
          <Modal
            isOpen={openRepostModal}
            onClose={() => setOpenRepostModal(false)}
          >
            <ChannelContextProvider>
              <RepostModal
                userId={userId}
                videoId={id}
                channelId={video?.channel?.id}
                userHasReposted={userHasReposted}
                setUserHasReposted={setUserHasReposted}
                setVideo={setVideo}
              />
            </ChannelContextProvider>
          </Modal>
        )}
      </Container>
      <ThinFooter />
    </ContentWrapper>
  );
};

export default VideoPage;
